<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="alert-critical-filled-separate_colors">
<path id="Vector" d="M87.5 50C87.5 70.7107 70.7107 87.5 50 87.5C29.2893 87.5 12.5 70.7107 12.5 50C12.5 29.2893 29.2893 12.5 50 12.5C70.7107 12.5 87.5 29.2893 87.5 50Z" fill="#CC1C10"/>
<g id="Center">
<path d="M54.1666 65.1862C54.1666 67.4874 52.3011 69.3529 49.9999 69.3529C47.6988 69.3529 45.8333 67.4874 45.8333 65.1862C45.8333 62.885 47.6988 61.0195 49.9999 61.0195C52.3011 61.0195 54.1666 62.885 54.1666 65.1862Z" fill="white"/>
<path d="M45.3099 35.8296C45.0324 33.0548 47.2114 30.6471 49.9999 30.6471C52.7885 30.6471 54.9675 33.0548 54.69 35.8296L52.8632 54.0975C52.7161 55.5685 51.4783 56.6888 49.9999 56.6888C48.5216 56.6888 47.2838 55.5685 47.1367 54.0975L45.3099 35.8296Z" fill="white"/>
</g>
</g>
</svg>
